<div class="page-container">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading">
      <fa-icon [icon]="faUsers" />
      Master Colour Detail
    </h1>
    <app-navpath />
  </div>
  <div class="mb-2 flex w-full flex-wrap gap-1 md:w-fit">
    <button
      *ngIf="mode === 'Add'"
      class="shorter-btn misc-btn"
      [disabled]="lockUpdate"
      (click)="SaveDetails()"
    >
      <fa-icon [icon]="faPlus" class="mr-1" />Create
    </button>
    <button
      *ngIf="mode === 'Edit'"
      class="shorter-btn misc-btn"
      [disabled]="lockUpdate"
      (click)="SaveDetails()"
    >
      <fa-icon [icon]="faPencil" class="mr-1" />Update
    </button>
    <button class="shorter-btn clear-btn" (click)="onCancel()">
      <fa-icon [icon]="faBan" class="mr-1" />Cancel
    </button>
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="formFields"
      (updateFields_child)="updateFields($event)"
    />
    <div
      class="grid grid-cols-1 gap-x-8 px-4 pb-4 text-sm md:grid-cols-2 lg:gap-x-14 lg:px-8"
    >
      <label
        class="flex w-full flex-col items-start lg:flex-row lg:items-center"
      >
        <span
          class="w-full font-bold md:pr-2 lg:w-1/3"
          [class.text-red-warning]="selectedInteriorColours.length === 0"
        >
          Interior Colours
        </span>
        <app-select-multiple-input
          class="w-full flex-grow lg:w-2/3"
          id="InteriorColours"
          [value]="selectedInteriorColours"
          [options]="availableInteriorColours"
          (dataOutput)="onInteriorColoursChange($event)"
        />
      </label>
    </div>
  </div>
</div>
